import { combineEpics } from 'redux-observable';
// ---- external imports ----

import employeesResetWorkCycleEpic from './employeesResetWorkCycleEpic';
import onHireBookkeeperEpic from './onHireBookkeeperEpic';

export default combineEpics(
	employeesResetWorkCycleEpic,
	onHireBookkeeperEpic
);
